import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';

/**
 * Access Denied page displayed when user lacks required permissions.
 * Shows clear message and navigation options.
 */
@Component({
  selector: 'app-access-denied',
  standalone: false,
  templateUrl: './access-denied.component.html',
  styleUrl: './access-denied.component.scss',
})
export class AccessDeniedComponent implements OnInit {
  requiredPermission: string | null = null;
  attemptedRoute: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) {}

  ngOnInit(): void {
    // Get permission info from query params if available
    this.route.queryParams.subscribe(params => {
      this.requiredPermission = params['permission'] || null;
      this.attemptedRoute = params['route'] || null;
    });
  }

  goBack(): void {
    this.location.back();
  }

  goToDashboard(): void {
    this.router.navigate(['/dashboard']);
  }
}
